export default __webpack_public_path__ + "static/sgLandmarksOptimized-ced069e49cd150359ecc35cd7ac78acb.mp4";